//Important:
//The order and permissions values must be equal at the backend
//Please refer BD.HSPA.WebApi\BD.HSPA.Data\Enums\HPSAPermission.cs file
export enum HSPAPermission {
    None = 0,
    OnboardingIDNs = 1,
    HospitalFacilitiesAccess = OnboardingIDNs * 2, //Value 2
    IDNsAccess = HospitalFacilitiesAccess * 2, // Value 4
    ManageDevices = IDNsAccess * 2, //Value 8
    ManageGroups = ManageDevices * 2, //Value 16
    ManageRoles = ManageGroups * 2, //Value 32
    ManageUsers = ManageRoles * 2, //Value 64
    OnboardingHospitalFacilities = ManageUsers * 2, //Value 128
    ViewClinician = OnboardingHospitalFacilities * 2, //Value 256
  }
  